'use strict';

wbApp.controller('InstructionsCtrl', ['$scope', '$timeout',
function ($scope, $timeout) {

    $scope.tabs = [
    {
        title: 'TXT_TAB_INSTRUCTIONS',
        template: 'instructions/instructions-tab.html'
    }];

    $scope.tabs.activeTab = 0;

    $timeout(function () {
        $('iframe.auto-height').iframeAutoHeight({ minHeight: 400, heightOffset: 40 });
    });
}]);